import { getAllDomains, getDomainConfig } from '../../lib/domainRegistry'
import type { Domain } from '../../lib/domainRegistry'

interface DomainSelectorProps {
  onSelect: (domain: Domain) => void
}

export function DomainSelector({ onSelect }: DomainSelectorProps) {
  const domains = getAllDomains()

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h2 className="text-lg font-semibold text-text-primary mb-2">Select a Domain</h2>
        <p className="text-body text-text-secondary">
          Choose the domain that best fits your project
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4">
        {domains.map((domain) => {
          const config = getDomainConfig(domain)
          if (!config) return null

          return (
            <button
              key={domain}
              onClick={() => onSelect(domain)}
              className="group relative flex flex-col gap-3 p-6 rounded-lg bg-bg-surface border border-border-subtle hover:border-current transition-all duration-200 hover:bg-bg-surface-hover cursor-pointer text-left"
              style={{
                borderColor: 'currentColor',
                '--tw-text-opacity': '1',
                color: `rgba(${parseInt(config.color.slice(1, 3), 16)}, ${parseInt(config.color.slice(3, 5), 16)}, ${parseInt(config.color.slice(5, 7), 16)}, 0.3)`,
              } as React.CSSProperties}
              onMouseEnter={(e) => {
                const element = e.currentTarget as HTMLElement
                element.style.color = config.color
                element.style.borderColor = config.color
              }}
              onMouseLeave={(e) => {
                const element = e.currentTarget as HTMLElement
                element.style.color = `rgba(${parseInt(config.color.slice(1, 3), 16)}, ${parseInt(config.color.slice(3, 5), 16)}, ${parseInt(config.color.slice(5, 7), 16)}, 0.3)`
                element.style.borderColor = 'var(--color-border-subtle)'
              }}
            >
              {/* Domain icon */}
              <div className="text-4xl">{config.icon}</div>

              {/* Domain label */}
              <h3 className="text-body font-semibold text-text-primary">
                {config.label}
              </h3>

              {/* Domain description */}
              {config.description && (
                <p className="text-body-sm text-text-secondary line-clamp-2">
                  {config.description}
                </p>
              )}
            </button>
          )
        })}
      </div>
    </div>
  )
}
